export default __webpack_public_path__ + "static/media/project_academia_de_lenguas_1.6f4e1c8c.png";